import React, { useContext, useEffect, useState } from "react";
import { Link } from "gatsby";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { AuthContext } from "../../context/AuthContext";
import { SITELER } from "../detay/UrunDetay";
import { tl } from "../FiyatGecmisi";
import GirisPenceresi from "./GirisPenceresi";
import { ilgiSay, takipDurumu, takipKaydet } from "./uyeApi";
import { olay } from "../../utils/olcum";
import "./uye.css";

// Az sayı ürünü ilgisiz gösterir ("3 kişi baktı"): eşiğin altında hiç yazılmaz
const GORUNTULENME_ESIK = 20;
const FAVORI_ESIK = 5;
const sayi = (n) => n.toLocaleString("tr-TR");

/**
 * İndirim detayı ve ürün sayfasında "🔔 Fiyat alarmı" + "♡ Favori". Üye değilse önce Google ile giriş penceresi, giriş
 * olunca istenen işlem kaldığı yerden yapılır. Amazon: sitede fiyat gösterilmez → pencerede şu anki fiyat yazmaz, hedef
 * fiyat önceden doldurulmaz (gizli fiyatı ele vermesin); e-postada fiyat yazar.
 * Props: site, urunId (mağazadaki ürün id), fiyat (şu anki, sayı), urunAdi.
 */
export default function TakipDugmeleri({ site, urunId, fiyat }) {
  const s = SITELER[site];
  const { isAuth } = useContext(AuthContext);
  const [durum, setDurum] = useState(null);
  const [girisAcik, setGirisAcik] = useState(false);
  const [bekleyen, setBekleyen] = useState(null); // giriş sonrası yapılacak: "favori" | "alarm"
  const [alarmAcik, setAlarmAcik] = useState(false);
  const [tur, setTur] = useState("HEDEF");
  const [hedef, setHedef] = useState("");
  const [mesaj, setMesaj] = useState("");
  const [isliyor, setIsliyor] = useState(false);
  const [ilgi, setIlgi] = useState(null); // { goruntulenme, favori }

  useEffect(() => {
    if (isAuth !== 1 || !urunId) { setDurum(null); return; }
    takipDurumu(site, urunId).then(setDurum).catch(() => setDurum(null));
  }, [isAuth, urunId, site]);

  // görüntüleme sayacı + favori sayısı (herkese açık; sayılar eşiğin altındaysa gösterilmez)
  useEffect(() => {
    if (!urunId) return;
    let iptal = false;
    ilgiSay(site, urunId).then((x) => { if (!iptal) setIlgi(x); }).catch(() => {});
    return () => { iptal = true; };
  }, [urunId, site]);

  useEffect(() => {
    if (fiyat && !hedef && !s.fiyatGizle) setHedef(String(Math.floor(fiyat * 0.9)));
  }, [fiyat]);

  // giriş penceresinden dönünce bekleyen işlem
  useEffect(() => {
    if (isAuth === 1 && bekleyen) {
      setGirisAcik(false);
      if (bekleyen === "favori") favoriDegistir(true);
      else setAlarmAcik(true);
      setBekleyen(null);
    }
  }, [isAuth, bekleyen]);

  const bildir = (m) => { setMesaj(m); setTimeout(() => setMesaj(""), 3500); };

  const favoriDegistir = async (zorla) => {
    if (isAuth !== 1) { setBekleyen("favori"); setGirisAcik(true); return; }
    const yeni = zorla === true ? true : !(durum && durum.favori);
    // İyimser: kalp hemen değişir, kayıt arkada (Azure → auth + uzak DB ~1-2 sn); olmazsa eski haline döner
    const onceki = durum;
    const oncekiIlgi = ilgi;
    if (ilgi && !!(durum && durum.favori) !== yeni) setIlgi({ ...ilgi, favori: Math.max(0, (ilgi.favori || 0) + (yeni ? 1 : -1)) });
    setDurum({ ...(durum || {}), favori: yeni });
    bildir(yeni ? "Favorilere eklendi ♥" : "Favorilerden çıkarıldı");
    if (yeni) olay("favori_ekle", { magaza: s.ad });
    try {
      const kayit = await takipKaydet(site, urunId, { favori: yeni });
      if (kayit) setDurum(kayit);
    } catch (e) {
      setDurum(onceki);
      setIlgi(oncekiIlgi);
      bildir(e.message);
    }
  };

  const alarmDugmesi = () => {
    if (isAuth !== 1) { setBekleyen("alarm"); setGirisAcik(true); return; }
    setAlarmAcik(true);
  };

  const alarmKur = async () => {
    const h = Number(String(hedef).replace(",", "."));
    if (tur === "HEDEF" && !(h > 0)) { bildir("Hedef fiyatı yaz"); return; }
    setIsliyor(true);
    try {
      setDurum(await takipKaydet(site, urunId, { alarmTur: tur, hedefFiyat: tur === "HEDEF" ? h : null }));
      setAlarmAcik(false);
      bildir("Alarm kuruldu 🔔 Fiyat düşünce e-posta göndereceğiz.");
      olay("alarm_kur", { magaza: s.ad, tur });
    } catch (e) {
      bildir(e.message);
    }
    setIsliyor(false);
  };

  const alarmKaldir = async () => {
    setIsliyor(true);
    try {
      setDurum(await takipKaydet(site, urunId, { alarmTur: "" }));
      setAlarmAcik(false);
      bildir("Alarm kaldırıldı");
    } catch (e) {
      bildir(e.message);
    }
    setIsliyor(false);
  };

  if (!urunId) return null;
  const alarmVar = durum && durum.alarmTur && durum.alarmDurum === "AKTIF";
  const bakan = ilgi && ilgi.goruntulenme >= GORUNTULENME_ESIK ? ilgi.goruntulenme : 0;
  const favorici = ilgi && ilgi.favori >= FAVORI_ESIK ? ilgi.favori : 0;
  const alarmYazisi = !alarmVar ? "Fiyat alarmı kur"
    : durum.alarmTur === "HEDEF" ? `Alarm: ${tl(durum.hedefFiyat)} altı` : "Alarm: her indirimde";

  return (
    <>
      <div className="uy-takip">
        <button type="button" className={"uy-takip-dugme" + (alarmVar ? " uy-takip-aktif" : "")} onClick={alarmDugmesi} disabled={isliyor}>
          <span aria-hidden="true">🔔</span> {alarmYazisi}
        </button>
        <button type="button" className={"uy-takip-dugme uy-favori" + (durum && durum.favori ? " uy-takip-aktif" : "")}
          onClick={() => favoriDegistir()} disabled={isliyor} aria-pressed={!!(durum && durum.favori)} aria-label="Favori">
          {durum && durum.favori ? <FavoriteIcon className="uy-kalp" aria-hidden="true" /> : <FavoriteBorderIcon className="uy-kalp" aria-hidden="true" />} Favori
        </button>
      </div>
      {(bakan > 0 || favorici > 0) && (
        <div className="uy-ilgi">
          {bakan > 0 && <span><span aria-hidden="true">👀</span> Son 24 saatte <b>{sayi(bakan)}</b> kişi baktı</span>}
          {favorici > 0 && <span><span aria-hidden="true">♥</span> <b>{sayi(favorici)}</b> kişi favoriye ekledi</span>}
        </div>
      )}
      {mesaj && <div className="uy-mesaj" role="status">{mesaj} {isAuth === 1 && <Link to="/alarmlarim/">Alarmlarım →</Link>}</div>}

      <GirisPenceresi acik={girisAcik} kapat={() => { setGirisAcik(false); setBekleyen(null); }}
        baslik={bekleyen === "favori" ? "Favorilere eklemek için giriş yap" : "Fiyat düşünce haber verelim"}
        aciklama="Ücretsiz. Google hesabınla tek tıkla devam et; fiyat düşünce e-posta gönderelim." />

      {alarmAcik && (
        <div className="uy-perde" onClick={() => setAlarmAcik(false)} role="presentation">
          <div className="uy-pencere" role="dialog" aria-modal="true" aria-label="Fiyat alarmı" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="uy-kapat" onClick={() => setAlarmAcik(false)} aria-label="Kapat">×</button>
            <div className="uy-ikon" aria-hidden="true">🔔</div>
            <h2>Fiyat alarmı</h2>
            {!s.fiyatGizle && fiyat && <p className="uy-aciklama">Şu anki fiyat: <b>{tl(fiyat)}</b></p>}
            <div className="uy-secenekler">
              {(
                <label className={"uy-secenek" + (tur === "HEDEF" ? " uy-secenek-secili" : "")}>
                  <input type="radio" name="tur" checked={tur === "HEDEF"} onChange={() => setTur("HEDEF")} />
                  <div>
                    <b>Belirlediğim fiyatın altına inince</b>
                    <span>Bir kez haber veririz.</span>
                    {tur === "HEDEF" && (
                      <div className="uy-hedef">
                        <input inputMode="decimal" value={hedef} placeholder={s.fiyatGizle ? "Örn. 1500" : undefined} onChange={(e) => setHedef(e.target.value.replace(/[^\d.,]/g, ""))} aria-label="Hedef fiyat" />
                        <span>TL</span>
                      </div>
                    )}
                  </div>
                </label>
              )}
              <label className={"uy-secenek" + (tur === "INDIRIM" ? " uy-secenek-secili" : "")}>
                <input type="radio" name="tur" checked={tur === "INDIRIM"} onChange={() => setTur("INDIRIM")} />
                <div>
                  <b>Gerçek bir indirim yakalayınca</b>
                  <span>Fiyat geçmişine göre gerçek indirim olduğunda, en fazla günde bir e-posta.</span>
                </div>
              </label>
            </div>
            <button type="button" className="uy-ana-dugme" onClick={alarmKur} disabled={isliyor}>{alarmVar ? "Alarmı güncelle" : "Alarmı kur"}</button>
            {alarmVar && <button type="button" className="uy-ikincil-dugme" onClick={alarmKaldir} disabled={isliyor}>Alarmı kaldır</button>}
            <p className="uy-kucuk">Ürünleri düzenli aralıklarla kontrol ediyoruz; çok kısa süren indirimleri kaçırabiliriz.</p>
          </div>
        </div>
      )}
    </>
  );
}
